import api from "./api";

const trustEventService = {
    getAll: async () => {
        const res = await api.get("/trustevent");
        return res.data;
    },

    getByUser: async (userId) => {
        const res = await api.get(`/trustevent/user/${userId}`);
        return res.data;
    },

    getByDevice: async (deviceId) => {
        const res = await api.get(`/trustevent/device/${deviceId}`);
        return res.data;
    },

    create: async (data) => {
        const res = await api.post("/trustevent", data);
        return res.data;
    },
};

export default trustEventService;